import Spacer from '@berlitz/spacer'
import LockUnlock1 from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/11-Lock-Unlock/LockUnlock1'
import InformationCircle from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/14-Alerts/InformationCircle'
import PortalLearningPathUnit from '@classes/LearningPathUnit'
import { Card, CardContent, CardHeader, Icon, IconCircle, Subtitle, Title } from '@components/LPCard/Common'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { TopTag } from '../Lesson/style'
import { Description, SubContainer } from './style'

interface BlockedUnlockedProps {
  Unit: PortalLearningPathUnit
  ActiveUnits?: PortalLearningPathUnit[]
}

export const BlockedUnlocked: React.FC<BlockedUnlockedProps> = ({ Unit, ActiveUnits = [] }) => (
  <Card type="speakingPanel" active={true}>
    <CardContent isElective={Unit?.IsFromElective}>
      <CardHeader>
        {Unit?.IsFromElective && (
          <TopTag color="info100">
            <FormattedMessage id="Elective" defaultMessage="Elective" />
          </TopTag>
        )}
        <Icon color="white">
          <IconCircle color="info100" />
          <LockUnlock1 />
        </Icon>
      </CardHeader>

      <Spacer size="md" />

      <Title color="info100">
        {ActiveUnits.length ? (
          <FormattedMessage id="Live coaching sessions unlocked!" />
        ) : (
          <FormattedMessage id="{name} unlocked" defaultMessage="{name} unlocked" values={{ name: Unit?.LCSTitle }} />
        )}
      </Title>

      <Spacer size="sm" />

      <SubContainer>
        <Subtitle color="text00">
          <FormattedMessage id="Only one coaching session can be booked at a time." />
          <Spacer size="xxs" />
          <Spacer size="md" />
          <FormattedMessage id="Return and book after your scheduled session has been completed." />
        </Subtitle>
      </SubContainer>

      <Spacer size="md" />

      <SubContainer color="info30">
        <InformationCircle />
        <Description color="text00">
          <FormattedMessage id="Practice what you've learnt with an instructor, online via video. (approx. 30 minutes)" />
        </Description>
      </SubContainer>
    </CardContent>
  </Card>
)

export default BlockedUnlocked
